export const dateUnformat = (date) => {
    if (date) {
        return date.split('/').reverse().join('-');
    }

    return 'Não Informado';
}

export const cpfUnformat = (cpf) => {
    if (cpf) {
        return cpf.replaceAll('.', '').replace('-', '');
    }

    return cpf;
}

export const phoneUnformat = (phone) => {
    return phone.replace(/[()-\s]/g, '');
}


// WEBPACK FOOTER //
// ./resources/assets/js/utils/unformat.js